const {config} = require('../../../config');
const sendSlackNotification = require('../../../bin/utils/sendSlackNotification');

module.exports = class Handlers {
  static HANDLER_TYPES = {
    slack: 'slack'
  };
  async slack(expectedErrorMessage) {
    let slackId, message;

    if (expectedErrorMessage !== '') {
      slackId = config.slack.marketingGroupID;
      message = `The publishing failed, reason is:\n\n${expectedErrorMessage}\n`;
    } else {
      slackId = config.slack.warnBotGroupID;
      message = `The deployment has been interrupted unexpectedly.\nFailing job: <${process.env.CI_JOB_URL}>`;
    }

    await sendSlackNotification(`<!${slackId}>\n${message}\nAffected environment: \`${config.gatsbyActiveEnv}\``);
  }
};
